import React from 'react'
import { useIntl } from 'react-intl'
import Modal from 'modals/dialog'

const RespondHero = () => {
    const { formatMessage } = useIntl()

    return (
        <Modal.Header
            heading={formatMessage({
                id: 'employee_satisfaction_heading_response',
                defaultMessage: 'Survey response'
            })}
            showDismiss={false} />
    )
}

export default RespondHero